import {
  HOTEL_LOCATION_TYPE_COLORS,
  HOTEL_LOCATION_TYPE_DEFAULT_LABEL,
  HOTEL_LOCATION_TYPE_LABELS,
  HOTEL_SEARCH_ICON_COLOR,
} from '../constants/hotelSearch.constants';

function hotelLocationTypeLabel(locationType) {
  const type = String(locationType || '').trim();
  if (HOTEL_LOCATION_TYPE_LABELS[type]) return HOTEL_LOCATION_TYPE_LABELS[type];
  if (!type) return HOTEL_LOCATION_TYPE_DEFAULT_LABEL;
  return type
    .toLowerCase()
    .split('_')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

function hotelLocationTypeColor(locationType) {
  const type = String(locationType || '').trim();
  return HOTEL_LOCATION_TYPE_COLORS[type] || HOTEL_SEARCH_ICON_COLOR.LOCATION;
}

export { hotelLocationTypeLabel, hotelLocationTypeColor };
